import React, {useState} from 'react'
import {Tab, Tabs} from 'react-bootstrap'
import ReactTooltip from 'react-tooltip'
import materialtextures from './config/material.json'
import './css/ConfiguratorPads.css'

const basedir = `${process.env.PUBLIC_URL}`;

export default function TextureSelectionPad (props) 
{

    const [section, setSection] = useState(props.defaultsection);
 
    const callSelect = e=>{
        props.select( e.target.dataset.texture );
    }


    let grids = {};

    props.sections.forEach(el => {
        grids[el] = Object.keys(materialtextures[el]).map( (descr, k)=>{
            const isColor = materialtextures[el][descr].charAt(0)==='#';
            const thestyle = isColor?
                                {backgroundColor: materialtextures[el][descr]}:
                                {backgroundImage: `url(${basedir}/textures/${materialtextures[el][descr]}`};
            
            return ( 
                <div key={`mat-${k}`}>
                    <div 
                        key={k}
                        style={thestyle}
                        data-item={el}
                        data-texture={JSON.stringify(
                                        {   'texture':descr, 
                                            'type': isColor?'color':'image', 
                                            'material': el 
                                        })
                                    }
                        className={`thumbnail${props.variation?` ${props.variation}-thumbnail`:''}`}
                        onClick={callSelect}
                        data-tip
                        data-for={`texttip-${k}`}
                    />
                    <ReactTooltip id={`texttip-${k}`} place="top" effect="solid">
                        {descr}                            
                    </ReactTooltip>
                </div>
            )
        } )
    });


    const thegrids = props.sections.map( s=>{
        return(
            <Tab
                key={s} 
                eventKey={s} 
                title={s.toUpperCase()}>
                <div key={`div-${s}`} className='texture-selector-panel col-12'>
                    {grids[s]}
                </div>
            </Tab>        
        )
    });


    return (
        <Tabs 
            className={`leggera-tab ${props.variation}`}
            activeKey={section}
            onSelect={val => setSection(val )}
        >
                {thegrids}
        </Tabs>
    );

}

